export const UPDATE_PROFILE_SECTION = 'UPDATE_PROFILE_SECTION';
export const ACCORDION_ACTION='accordion_state_action';
export const UPDATE_GLOBAL_STATE='update_data';
export const SET_LOADER='set_loader';
